import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";

const TermsOfService: React.FC = () => {
  return (
    <div className="d-flex flex-column mb-5" style={{ height: '100%', backgroundColor: '#F8F5EE' }}>
      <ScrollToTop />

      {/* Breadcrumb */}
      <div className="py-3">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 font_two">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none active text-dark ">
                  Home
                </Link>
              </li>
              <li
                className="breadcrumb-item fw_700 font-medium"
                aria-current="page"
              >
                Terms of Service
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container flex-grow-1 py-4">
        <div className="container flex-grow-1 d-flex flex-column flex-md-row py-4">
          {/* Left Column - Title and Subtitle */}
          <div className="col-lg-4 col-md-5 mb-4 mb-md-0">
            <h1 className="mb-3" style={{
              fontSize: '2.5rem',
              fontWeight: '500',
              color: '#1A3A4A',
              fontFamily: "'Lora', serif",
              lineHeight: '1.2'
            }}>
              Terms of Service
            </h1>
            <p className="text-muted mb-0 font-satoshi" style={{
              fontSize: '1rem',
              lineHeight: '1.5',
              color: '#333333',
              fontFamily: 'Satoshi, sans-serif',
              textAlign:'justify'
            }}>
              These Terms of Service govern your use of our website and digital products.
            </p>
          </div>
          {/* Vertical Divider */}
          <div className="d-none d-lg-block" style={{
            padding: '0.5px',
            backgroundColor: '#112C3B4D',
            margin: '0 2rem',
            alignSelf: 'stretch'
          }}>
          </div>

          {/* Right Column - Terms Content */}
          <div className="col-lg-8 col-md-7">
            <div className="terms-content" style={{ lineHeight: '1.7', fontFamily: 'Satoshi, sans-serif', textAlign:'justify' }}>
              <p className="mb-4" style={{ fontSize: '1rem', color: '#333333' }}>
                By accessing or purchasing from our website, you agree to the following Terms of Service.
                Please take a moment to read them carefully before using our platform.
              </p>

              <p className="mb-4" style={{ fontSize: '1rem', color: '#333333' }}>
                Our website is intended for individuals who are at least 18 years old, or those who have
                the consent of a parent or guardian. By using this platform, you agree not to misuse our
                services, attempt unauthorized access, or interfere with the website's functionality.
              </p>

              <p className="mb-4" style={{ fontSize: '1rem', color: '#333333' }}>
                All products sold on this website are digital artworks unless otherwise specified. Once
                your payment is confirmed, you will receive instant access to your files via a download
                link or email. As these are digital products, no physical item will be shipped.
              </p>

              <p className="mb-4" style={{ fontSize: '1rem', color: '#333333' }}>
                When you purchase an artwork, you are granted a license for personal use only, unless
                you have explicitly purchased a commercial license. This means you may print the artwork
                for home or office décor and use it on your personal devices or digital displays. However,
                you are not permitted to resell, redistribute, or share the files, claim them as your own,
                or use them for commercial purposes without the appropriate license.
              </p>

              <p className="mb-0" style={{ fontSize: '1rem', color: '#333333' }}>
                Please note that due to the digital nature of our products, all sales are final and
                non-refundable. If you encounter any issues with your download or file access, you can
                contact us at{" "}
                <a href="mailto:support@digicartt.com" style={{ color: '#1A3A4A', textDecoration: 'underline' }}>
                  support@digicartt.com
                </a>
                , and we will be happy to assist you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
